export const INVOICES = {
  RECEIVE_ORDER_CONFIRMATION: 'invoices/receive_order_confirmation',
};

export type ReceiveOrderConfirmationAction = {
  type: typeof INVOICES.RECEIVE_ORDER_CONFIRMATION,
  order: Object,
};

export function receiveOrderConfirmation(
  order: Object
): ReceiveOrderConfirmationAction {
  return {
    type: INVOICES.RECEIVE_ORDER_CONFIRMATION,
    order,
  };
}
